export type BrandSourceAd = {
  id: string;
  brand: string;
  destinationUrl: string | null;
};

export type BrandDirectoryEntry = {
  slug: string;
  name: string;
  adCount: number;
  homepageUrl: string | null;
  heroPath: string;
};

const seededBrands: Array<Pick<BrandDirectoryEntry, "slug" | "name" | "homepageUrl">> = [
  { slug: "offmarket-men", name: "OffMarket Men", homepageUrl: "https://offmarketmen.com/" },
];

export function brandSlug(value: string): string {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/gu, "").toLowerCase().replace(/[^a-z0-9]+/gu, "-").replace(/^-+|-+$/gu, "");
}

function homepageUrl(value: string | null): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    return `${url.protocol}//${url.host}/`;
  } catch {
    return null;
  }
}

export function brandHomepageDomain(value: string | null): string | null {
  if (!value) return null;
  try {
    const hostname = new URL(value).hostname.replace(/^www\./u, "");
    return hostname ? `${hostname.slice(0, 1).toUpperCase()}${hostname.slice(1)}` : null;
  } catch {
    return null;
  }
}

export function buildBrandDirectory(ads: BrandSourceAd[]): BrandDirectoryEntry[] {
  const brands = new Map<string, BrandDirectoryEntry>();
  for (const ad of ads) {
    const name = ad.brand.trim();
    if (!name || name.startsWith("[")) continue;
    const slug = brandSlug(name);
    if (!slug) continue;
    const current = brands.get(slug);
    if (current) {
      current.adCount += 1;
      current.homepageUrl ??= homepageUrl(ad.destinationUrl);
      continue;
    }
    brands.set(slug, { slug, name, adCount: 1, homepageUrl: homepageUrl(ad.destinationUrl), heroPath: `/brand-heroes/${slug}.png` });
  }
  for (const seeded of seededBrands) {
    if (!brands.has(seeded.slug)) brands.set(seeded.slug, { ...seeded, adCount: 0, heroPath: `/brand-heroes/${seeded.slug}.png` });
  }
  return [...brands.values()].sort((left, right) => left.name.localeCompare(right.name));
}
